export function isRealNumber(value: any): value is number {
  if (typeof value === "string") {
    value = Number.parseInt(value);
  }
  return typeof value === "number" && !isNaN(value);
}
